import React, { useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    MenuItem
} from '@mui/material';
import { postApartado } from '../../services/apis';

const getInitialForm = (year) => ({
    nombre: '',
    year
});

export const AnadirIngresoDialog = ({ open, onClose, onAdd, year, anios = [], cargarDatos }) => {
    const [form, setForm] = useState(getInitialForm(year));

    const resetForm = () => {
        setForm(getInitialForm(year));
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const carsubirApartado = async () => {
        const payload = {
            ...form,
            year: form.year
        };

        try {
            const response = await postApartado(payload);
            if (response?.success === true) {
                await cargarDatos();
                onAdd(response.data);
                handleClose();
            } else {
                console.error("Error en afegir l'apartat:", response);
            }
        } catch (error) {
            console.error("Error en afegir l'apartat:", error);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Afegir apartat</DialogTitle>
            <DialogContent>
                <Box className="ki-form-stack">
                    <TextField
                        select
                        fullWidth
                        label="Any comptable"
                        name="year"
                        value={form.year}
                        onChange={handleChange}
                    >
                        {anios.map((anyo) => (
                            <MenuItem key={anyo} value={anyo}>{anyo}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Nom"
                        name="nombre"
                        type="text"
                        value={form.nombre}
                        onChange={handleChange}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel·lar</Button>
                <Button variant="contained" onClick={carsubirApartado}>Afegir</Button>
            </DialogActions>
        </Dialog>
    );
};
